<template>
  <div class="">
    <div
      class="subheading"
      style="margin-top: -8px;"
    >
      Boendeform
    </div>
    <v-chip-group
      v-model="selection"
      active-class=""
      color="secondary"
      mandatory
      column
    >
      <v-chip
        v-for="lodgingType in lodgingTypes"
        :key="lodgingType.id"
        :value="lodgingType"
        outlined
        class="lodging-type-picker-chip"
      >
        <v-icon :color="selection.id === lodgingType.id ? 'secondary' : 'primary'">
          {{ lodgingType.lodging_type_icon }}
        </v-icon>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>

export default {
  name: 'LodgingTypePicker',
  props: {
    value: Object,
    lodgingTypes: Array
  },
  data: () => ({}),
  computed: {
    selection: {
      get: function () {
        return this.value
      },
      set: function (lodgingType) {
        this.$emit('input', lodgingType)
      }
    }
  }
}
</script>
